import {create} from 'zustand';
import {UseSelectedProfessionalStoreProps} from './types';

export const useSelectedProfessionalStore = create<UseSelectedProfessionalStoreProps>(set => ({
	professional: null,
	setProfessional: professional => set({professional}),
	reset: () => set({professional: null}),
}));
